import React from 'react';
import { CLOUDFLARE_BASE } from '../../pages/Dashboard/AvLibrary/data/videos';

// The mission film, hosted on Cloudflare Stream like the Av Library videos
// (it used to ship inside the site as /video/mission.mp4). Played in the
// homepage and Investors modals.
const MISSION_VIDEO_ID = '87f3dbb481afd2d12438a99fa6ae93c3';

const MissionVideo = () => (
  <div className="relative w-full bg-black" style={{ aspectRatio: '16 / 9' }}>
    <iframe
      src={`${CLOUDFLARE_BASE}/${MISSION_VIDEO_ID}/iframe?autoplay=true`}
      title="NuVola AI mission"
      allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
      allowFullScreen
      className="absolute inset-0 h-full w-full border-0"
    />
  </div>
);

export default MissionVideo;
